import { useRefreshSignals } from './useRefreshSignals';

/**
 * Fires the refresh-on-read POST once per mount, StrictMode-safe (bead .17,
 * U7). This is intentionally a thin wrapper: `useRefreshSignals` is already
 * a `useQuery` on `['flow-signals-refresh']` with no manual `enabled`/mount
 * effect of its own — mounting it is what fires it, via TanStack's normal
 * "fetch a fresh, unmounted-elsewhere query key on mount" behavior. Do NOT
 * add a lifetime "already ran" ref guard here — see this bead's "Resolved"
 * note and `docs/v4-system/strictmode-resilient-effects.md`: a ref reset at
 * the top of a mount effect fires TWICE under StrictMode, which is the
 * opposite of what this hook needs.
 */
export function useRefreshOnMount(): void {
  useRefreshSignals();
}
